import axios from 'axios';
import { MessagePlugin } from 'tdesign-vue-next';
import router from '@/router';

function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts: any = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

// 创建http实例
const $http = axios.create({
  baseURL: '/software-platform/plantformapi',
  timeout: 6000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

// 请求拦截
$http.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers = {
    token: localStorage.getItem('token') || '',
    'x-csrf-token': getCookie('csrfToken'),
    'x-time-stamp': new Date().getTime()
  };
  return config;
});

// 处理请求的返回值
$http.interceptors.response.use(
  (res) => {
    const code: number = res.data.code;
    if (code == 401) {
      MessagePlugin.error(res.data.message);
      localStorage.setItem('token', '');
      localStorage.setItem('user', '');
      router.push({ path: '/login' });
    }
    if (code !== 200) {
      return Promise.reject(res.data);
    }
    return res.data;
  },
  (err) => {
    console.log(err);
  }
);

const $pag = axios.create({
  baseURL: '/software-platform',
  timeout: 300000,
  headers: {
    'Content-Type': 'multipart/form-data;'
  }
});
// 请求拦截
$pag.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers = {
    token: localStorage.getItem('token') || '',
    'x-csrf-token': getCookie('csrfToken')
  };
  return config;
});

// 处理请求的返回值
$pag.interceptors.response.use(
  (res) => {
    const code: number = res.data.code;
    if (code == 401) {
      MessagePlugin.error(res.data.message);
      localStorage.setItem('token', '');
      localStorage.setItem('user', '');
      router.push({ path: '/login' });
    }
    if (code !== 200) {
      return Promise.reject(res.data);
    }
    return res.data;
  },
  (err) => {
    console.log(err);
  }
);

export { $http, $pag };
